import { useSelector } from 'react-redux'
import classNames from 'classnames'
import styles from './CoachDashboardHome.module.scss'
import CoachDashboardQuickActions from './CoachDashboardQuickActions'
import CoachDashboardProgramsOverview from './CoachDashboardProgramsOverview'
import CoachDashboardCalendar from './CoachDashboardCalendar'
import CoachDashboardSchedule from './CoachDashboardSchedule'
import CoachDashboardSupport from './CoachDashboardSupport'
import CoachOnboardingWidget from './coachOnboarding/CoachOnboardingWidget'
import { selectIsOnboardingEnabled } from '../../../reducers/coachOnboardingReducer'
import GenericFeedComponent from '../../classes/program-dashboard-manager/overview-tab/GenericFeedComponent'

const CoachDashboardHome = () => {
  const isCoachOnboardingEnabled = useSelector(selectIsOnboardingEnabled)
  const { id: communityId, ongoing_events_count } = useSelector(state => state.user.current_user.communities[0])

  return (
    <div
      className={
        classNames(styles.coachDashboardHome, {
          [styles.onboardingInProgress]: isCoachOnboardingEnabled,
          [styles.onboardingAndEventBanner]: isCoachOnboardingEnabled && ongoing_events_count > 0,
        })
      }
    >
      {isCoachOnboardingEnabled ? <CoachOnboardingWidget /> : <GenericFeedComponent id={communityId} type='community'/>}
      <div className={styles.dashboardContent}>
        <CoachDashboardQuickActions communityId={communityId}/>
        <div className={styles.dashboardWidgetWrapper}>
          <div>
            <CoachDashboardCalendar/>
            <CoachDashboardProgramsOverview communityId={communityId}/>
          </div>
          <div>
            <CoachDashboardSchedule communityId={communityId}/>
            <CoachDashboardSupport/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoachDashboardHome
